const THREE = require('three')
import {loadingManager, load, registerSize} from '../loader'
import {TweenMax, SteppedEase, Cubic} from 'gsap'

const frames = 30
const fps = 45

// GEOMETRY
let geometry = new THREE.PlaneBufferGeometry(85, 85)

// CANVAS
let canvas = document.createElement('canvas')
canvas.width = 256
canvas.height = 256
let ctx = canvas.getContext('2d')
// canvas.setAttribute('style', 'opacity: 1; z-index: 100001; position: absolute; top: 0; left: 0')
// document.body.appendChild(canvas)


// MATERIAL
let material = new THREE.MeshBasicMaterial({
  transparent: true,
  opacity: 0,
  alphaTest: 0.1,
  map: new THREE.CanvasTexture(canvas)
})
material.depthTest = false
material.depthWrite = false

// MESH
export let mesh = new THREE.Mesh(geometry, material)
export default mesh
mesh.scale.setScalar(1.5)
mesh.position.x = 10
mesh.position.y = -25

let url = require('assets/race/scroll-spritesheet.png')

// PLAY
export const play = function () {
  const time = frames / fps

  TweenMax.to({x: 0}, time, {
    x: frames - 1,
    ease: SteppedEase.config(frames - 1),
    onUpdateParams: ['{self}'],
    repeat: -1,
    onUpdate: (tween)=> {
      let x = tween.target.x
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      ctx.drawImage(img, x * 200, 0, 200, 200, 0, 0, 200, 200)
      material.map.needsUpdate = true
    }
  })
}


let img = new window.Image()

registerSize(url, 11719)
load(url, new THREE.TextureLoader(loadingManager), ()=> {
  img.onload = ()=> {
    play()
  }
  img.src = url
})



// SHOW
export const show = function (time = 1) {
  TweenMax.to(material, time, {
    opacity: 1,
    ease: Cubic.easeIn
  })
}

// HIDE
export const hide = function (time = 1) {
  // mesh.position.z = 3
  TweenMax.to(material, time, {
    opacity: 0,
    ease: Cubic.easeIn
  })
}






// WEBPACK FOOTER //
// ./src/components/game/ui/scrollCta.js